// src/components/GenericErrorPage.js

import React from 'react';
import { useError } from './ErrorContext';
import { Link } from 'react-router-dom';

const GenericErrorPage = () => {
  const { errorMessage, clearError } = useError();

  return (
    <div style={styles.container}>
      <h1 style={styles.heading}>Oops! Something went wrong</h1>
      <p style={styles.message}>{errorMessage}</p>
      <Link to="/" onClick={clearError} style={styles.homeButton}>
        Go Back Home
      </Link>
    </div>
  );
};

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100vh',
    backgroundColor: '#f7f7f7',
    textAlign: 'center',
  },
  heading: {
    fontSize: '3rem',
    color: '#333',
  },
  message: {
    color: '#666',
    fontSize: '1.2rem',
  },
  homeButton: {
    padding: '10px 20px',
    marginTop: '20px',
    backgroundColor: '#333',
    color: '#fff',
    textDecoration: 'none',
    borderRadius: '8px',
  },
};

export default GenericErrorPage;
